"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newDeliveryApi = void 0;
const axios_1 = require("axios");
const newDeliveryApi = async (axiosInstance, form) => {
    try {
        const data = await axiosInstance.post(`/supply/delivery`, form);
        return data.data;
    }
    catch (error) {
        if ((0, axios_1.isAxiosError)(error)) {
            throw error.response?.data;
        }
        throw error;
    }
};
exports.newDeliveryApi = newDeliveryApi;
//# sourceMappingURL=supply.js.map